/** 模型推理模块根路径；已开通时由 MenuRedirect 按菜单权限跳转到首个可访问子页 */
export const MODEL_INFERENCE_BASE = '/model-inference';

export const MODEL_INFERENCE_INTRO_PATH = '/model-inference/intro';
export const MODEL_INFERENCE_ACTIVATION_PATH = '/model-inference/activation';

/** 未开通产品也可访问的页面（产品介绍、开通流程） */
export const MODEL_INFERENCE_PUBLIC_PATHS = [
  MODEL_INFERENCE_INTRO_PATH,
  MODEL_INFERENCE_ACTIVATION_PATH,
] as const;

export function isModelInferencePublicPath(pathname: string) {
  return MODEL_INFERENCE_PUBLIC_PATHS.some(
    (p) => pathname === p || pathname.startsWith(`${p}/`),
  );
}

/** 已开通后才可访问的业务页（不含根路径入口，根路径由 MenuRedirect 处理） */
export function isModelInferenceProtectedPath(pathname: string) {
  if (!pathname.startsWith(MODEL_INFERENCE_BASE)) return false;
  if (pathname === MODEL_INFERENCE_BASE) return false;
  return !isModelInferencePublicPath(pathname);
}

/** @deprecated 请使用 isModelInferenceProtectedPath */
export function isModelInferenceConsolePath(pathname: string) {
  return isModelInferenceProtectedPath(pathname);
}
